<template>
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0 required"> {{ $t('status') }} </label>
        <app-input 
            class="col-md-8 mt-2 pt-1" 
            type="radio" 
            :list="list" 
            v-model="selected" 
        />
    </div>
</template>
 
<script>
    export default {
        name: 'ShortName',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            list : {
                type: [Array],
                default : [],
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>